import uniqueId from "lodash/uniqueId";
import { useState } from "react";
import LabelFormElement from "../../../components/misc/LabelFormElement";
import { T } from "../../../index";
import { ThemeUIStyleObject } from "../../../nessie/stylingLib";
import { BaseSlider } from "./BaseSlider";

type SliderProps = {
  ["aria-label"]?: string;
  label: string;
  defaultValue?: number[];
  min?: number;
  max?: number;
  step?: number;
  className?: string;
  value?: number[];
  onChange: (value: number[]) => void;
  theme?: "light" | "dark";
};

export const Slider = ({
  label,
  defaultValue = [50],
  max = 100,
  min = 0,
  step = 1,
  className,
  onChange,
  value,
  "aria-label": ariaLabel,
  theme,
}: SliderProps) => {
  const [sliderId] = useState(uniqueId("sliderId"));
  const textColor = theme === "light" ? "dt_content_light" : "dt_content_primary";
  return (
    <div sx={{ width: "100%" }} className={className}>
      <LabelFormElement
        sx={{ textAlign: "center", color: textColor }}
        kind={theme === "light" ? "light" : "primary"}
        labelText={label}
        htmlFor={sliderId}
      />
      <div sx={{ marginBottom: "s", display: "flex", justifyContent: "space-between", alignItems: "center", gap: "l" }}>
        <span sx={{ ...iconStyles, color: textColor }}>
          <T str="dojo.common:minus_char" fallback="-" />
        </span>
        <BaseSlider
          defaultValue={defaultValue}
          min={min}
          max={max}
          step={step}
          aria-label={ariaLabel || label}
          onChange={onChange}
          value={value}
          id={sliderId}
        />
        <span sx={{ ...iconStyles, color: textColor }}>
          <T str="dojo.common:plus_char" fallback="+" />
        </span>
      </div>
    </div>
  );
};

const iconStyles: ThemeUIStyleObject = {
  fontSize: "30px",
  fontWeight: "600",
};
